// 詳細ペインの PDF プレビューで表示中のページ番号を保持する。
// 拡大モーダルを開いたときに同じページから表示するために使う。
import { ref, watch } from 'vue';

export const useDetailPreviewPage = ({ selectedItem }) => {
  const detailPreviewPage = ref(null);

  const handleDetailPageChange = (pageNumber) => {
    detailPreviewPage.value = Number.isInteger(pageNumber) && pageNumber >= 1 ? pageNumber : null;
  };

  // 選択ファイルが切り替わったら、前のファイルのページ番号を捨てる
  // (useSearchMatches の activeDetailPage と同じく、後段の代入より先に走らせるため flush: 'sync')。
  watch(
    selectedItem,
    (next, prev) => {
      const nextId = next ? String(next.id) : null;
      const prevId = prev ? String(prev.id) : null;
      if (nextId !== prevId) {
        detailPreviewPage.value = null;
      }
    },
    { flush: 'sync' }
  );

  return {
    detailPreviewPage,
    handleDetailPageChange,
  };
};
